module.exports = __webpack_public_path__ + "img/emoji_10.22c9552d.png";